// START always import these first!!
import './bootstrap/raven';
import './publicPath';
// END always import these first!!
import initClient from './initClient';

initClient();
